import { createClient } from '@supabase/supabase-js';

// Public values (safe to ship — they are visible in the live site anyway). .env can override them.
const url = process.env.REACT_APP_SUPABASE_URL || 'https://kaeculipwxpmztiuhtnd.supabase.co';
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_lic83uLtyFSNO0Baxp6H3A_y6iGs4JC';

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.error(
    '[Posterly] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. ' +
      'Add them to frontend/.env (local) or Vercel → Settings → Environment Variables.'
  );
}

export const supabase = createClient(url || 'http://missing-supabase-url', anonKey || 'missing-key', {
  auth: { persistSession: true, autoRefreshToken: true },
});

export const IMAGE_BUCKET = 'posterly-images';
